<template>
    <div class="v-empty">
        <h6 class="v-empty__text">{{ message }}</h6>
    </div>
</template>

<script>
import { provideLocalizationService } from "@progress/kendo-vue-intl";

export default {
    props: {
        text: {
            type: String,
            required: false,
        }
    },
	inject: {
		kendoLocalizationService: { default: null },
	},
	computed: {
        message() {
            if(this.text) {
                return this.text;
            }
            return provideLocalizationService(this).toLanguageString(
                "emptyText",
                "emptyText"
            );
        }
	}
}
</script>

<style lang="scss" scoped>
.v-empty {
    padding: 2rem 0;

    &__text {
        text-align: center;
        font-size: 18px;
        color: #000;
    }
}
</style>